<template>
  <div class="d-flex flex-column flex-root">
    <div
      class="login otp d-flex flex-column flex-lg-row flex-column-fluid bg-white"
      id="kt_sign_iv"
    >
      <div
        class="login-content flex-row-fluid d-flex flex-column justify-content-center position-relative overflow-hidden p-7 mx-auto"
      ></div>
    </div>
  </div>
</template>

<script>
import { saveToken } from "@/core/services/jwt.service";
import { VERIFY_USER } from "@/core/services/store/profile.module";
import { PURGE_AUTH, SET_AUTH } from "@/core/services/store/auth.module";

export default {
  name: "signIn",
  beforeMount() {
    this.$store.commit(PURGE_AUTH);

    if (this.$route.query.token) {
      saveToken(this.$route.query.token.toString());
    }
  },
  mounted() {
    this.$store
      .dispatch(VERIFY_USER)
      .then(() => {
        this.$store.commit(SET_AUTH, {
          token: this.$route.query.token.toString()
        });

        this.$router.push({ name: "dashboard" });
      })
      .catch(() => {
        this.$router.push({ name: "otp" });
      });
  }
};
</script>
